export const QA_NAME_REQUEST_TAG_ITEM = 'request'
